import React from 'react';
export default function Paragraph({ text }) {
    return React.createElement("div", { className: "ltg-paragraph-wrap", dangerouslySetInnerHTML: { __html: text } });
}
